<template>
    <LRLayout>
        <LeftPanel v-loading="loading">
            <el-tree v-if="data.length" ref="tree" :data="data" :props="defaultProps" :default-expanded-keys="defaultExpandedKeys" highlight-current node-key="id" @node-click="handleNodeClick">
                <span slot-scope="{ node, data }">
                    <span>
                        <svg-icon v-if="data.icon" :icon-class="data.icon" style="width: 12px; height: 12px" />
                        <span style="font-size: 12px">{{ node.label }}</span>
                    </span>
                </span>
            </el-tree>
            <div v-else class="empty-tree">暂无数据</div>
        </LeftPanel>
        <RightPanel v-loading="loading">
            <div class="app-container">
                <!-- <data-table v-if="showView === 'listpage'" :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-delete-successed="onDeleteSuccessed"></data-table> -->
                <data-table v-if="showView === 'listpage'" ref="dataTable" class="dataTable" :module-info="moduleInfo" :tb-columns="tableList" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange" :cell-selection-status="cellSelectionStatus"></data-table>
            </div>
        </RightPanel>
        <Basicform ref="basicform" :title="formTitle" :module-code="moduleInfo.moduleCode" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps">
                <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </LRLayout>
</template>

<script>

export default {
    props: {
        pageType: { type: String, default: null }
    },
    data: function () {
        return {
            showView: 'listpage',
            loginUser: {},
            moduleInfo: { formTemplate: 'dcontent/busiformurl?vwtype=W&url=/dagl/vwDaglFileFolder/form.html', addNewUrl: 'dagl/vwDaglFileFolder/addNew', insertUrl: 'dagl/vwDaglFileFolder/insert', getByIdUrl: 'dagl/vwDaglFileFolder/getById', updateUrl: 'dagl/vwDaglFileFolder/update', delUrl: 'dagl/vwDaglFileFolder/delete', listDataUrl: 'dagl/vwDaglFileFolder/listdata', winWidth: 1000, winHeight: 600, moduleCode: 'fgsgl', openViewType: '0', listAdvSearchAllFields: 0, listAdvSearchExpandPanel: 0 },
            tableList: [
                {
                    field: 'state',
                    checkbox: true,
                    width: '45px'
                },
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                {
                    propFormatter: 'component：@/wapp/dagl/zlcx/components/tbColumns',
                    field: 'fileName',
                    title: '文件名称',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 0
                },
                {
                    field: 'folderType',
                    title: '资料类型',
                    width: '150px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: true,
                    searchable: false,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3,
                    elementFormatter: '',
                    propFormatter: 'function：operateActualSize'
                },
                {
                    field: 'creator',
                    title: '创建人',
                    width: '100px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: false,
                    searchable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3,
                    elementFormatter: ''
                },
                {
                    field: 'createDate',
                    title: '创建时间',
                    width: '150px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'date',
                    elementFormatter: 'format：yyyy-MM-dd HH:mm\r\n',
                    listAdvSearchIndex: 4
                }
            ],
            listStyle: {},
            listpageBtns: [
                // { id: 'btn_add', btnType: 'toolbar', btnName: '新增', btnIcon: 'plus', btnPermission: 'addObject', btnClick: 'addObject();', btnI18nCode: 'add' },
                // { id: 'btn_deleteIds', btnType: 'toolbar', btnName: '删除', btnIcon: 'close', btnPermission: 'deleteIds', btnClick: 'deleteIds();', btnI18nCode: 'delete' },
                // { id: 'btn_edit', btnType: 'column', btnName: '编辑', btnIcon: 'edit', btnPermission: 'editObject', btnClick: 'editObject(row.id);', btnI18nCode: 'edit' },
                // { id: 'btn_deleteId', btnType: 'column', btnName: '删除', btnIcon: 'delete', btnPermission: 'deleteIds', btnClick: 'deleteIds(row.id);', btnI18nCode: 'delete' }
            ],
            busiformBtns: [],
            formTitle: '资料查询',
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            data: [],
            currentData: {},
            currentDataid: '',
            defaultExpandedKeys: [] // 默认展开第一个节点
        }
    },
    computed: {},
    watch: {
        $route: function (a, b) {
            this.setShowView()
        }
    },
    created: function () {
        this.getTreeList()
        // 刷新列表
        this.$bus.$on('setListDataUrl', this.setListDataUrl)
        //列表页面配置ID
        // this.moduleInfo.listpageViewUrl = '/dagl/vwDaglFileFolder/list.html'
        const _this = this
        this.listpageBtns.forEach(function (btn) {
            btn.btnParams = null
            if (typeof btn.btnClick === 'string') {
                let btnClick = btn.btnClick
                if (btn.btnClick.indexOf('(') !== -1) {
                    let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                    if (btnParams !== '') {
                        btnParams = btnParams.replace(/'/g, '').replace(/ /g, '').split(',')
                        btn.btnParams = btnParams
                    }
                    btnClick = btnClick.split('(')[0]
                }
                if (_this[btnClick]) {
                    btn.btnClick = _this[btnClick]
                }
            }
        })

        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    beforeDestroy: function () {
        // 刷新列表
        this.$bus.$off('setListDataUrl', this.setListDataUrl)
    },
    mounted: function () {
        this.setShowView()
    },
    methods: {
        // 树节点点击
        handleNodeClick(data) {
            console.log('data', data)
            this.currentDataid = data.id
            this.$bus.emit('refreshListData')
        },
        getTreeList() {
            // this.loading = true
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `dagl/xmzlFolder/listdata`,
                method: 'POST',
                params: {
                    pageNum: 1,
                    pageSize: 9999
                }
            }).then((res) => {
                if (res.code === 'success') {
                    console.log(res)
                    this.data = [{ name: '全部', id: '0', children: (this.data = this.treeDataAdapter(res.body.pageInfo.list)) }]
                    // this.data = this.treeDataAdapter(res.body.pageInfo.list)
                    if (this.data[0].children) {
                        if (this.data[0].children[0].children) {
                            this.defaultExpandedKeys.push(this.data[0].id)
                            this.currentData = this.data[0]
                            this.$nextTick(() => {
                                this.$refs['tree'].setCurrentKey(this.currentData.id)
                            })
                        }
                    }
                } else {
                    this.loading = false
                }
            })
        },
        cellclick(row) {
            var id = ''
            var ids = ''
            var name = ''
            var type = row.type
            id = row.id
            name = row.fileName
            ids = row.downId
            this.id = id

            if (Number(row.flType) === 2) {
                // 打开目录

                this.setListDataUrl(row.id)
            } else {
                // 文件
                // if (!row.id) return
                // window.open('./plugins/PDFjs/web/viewer.html?file=' +encodeURIComponent(window.location.protocol + '//' + window.location.host + process.env.VUE_APP_BASE_API + `${this.downloadUrl}?inline=true&attachIds=` + id + '&fileName=' + name))

                if (name.indexOf('.ofd') > -1) {
                    let downUrl = process.env.VUE_APP_BASE_API + this.downloadUrl + '?inline=true&attachIds=' + id + '&fileName=' + name + '&saveAs=' + name
                    window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
                } else {
                    window.open(process.env.VUE_APP_BASE_API + `${this.downloadUrl}?inline=true&attachIds=` + id + '&saveAs=' + name)
                }
            }
        },
        setListDataUrl(id) {
            this.currentDataid = id
            this.defaultExpandedKeys.push(id)
            this.$nextTick(() => {
                this.$refs['tree'].setCurrentKey(this.currentDataid)
            })
            this.$bus.emit('refreshListData')
        },
        treeDataAdapter(allTreeData) {
            const _this = this
            let treeData = JSON.parse(JSON.stringify(allTreeData))

            for (let i = 0; i < treeData.length; i++) {
                const node = treeData[i]

                node.checked = false
                if (node.type) node.type = node.type.replace(/\s*/g, '')

                // 选择机构目录、主机构
                node.pId = node.pId || node.parentId || node.treeId || -1
                node.nodeKeyId = node.id + node.pId
                node.level = node.fullId.split('-').length
                node.name = node.nName || node.folderName

                node.canSelect = true

                if (node.orgFullId && !node.orgLevel && !node.olevel) {
                    node.orgLevel = node.orgFullId.split('-').length
                }
            }
            // 首先将所有节点存储在字典中
            const nodesDict = {}
            treeData.forEach((item) => {
                nodesDict[item.id] = item
            })

            // 创建一个存储根节点的数组
            const roots = []

            // 再次遍历字典，将每个节点添加到它的父节点中
            Object.values(nodesDict).forEach((item) => {
                if (!item.parentId) {
                    // 如果pId为空，则该节点为根节点
                    roots.push(item)
                } else {
                    let parent = nodesDict[item.parentId]
                    if (parent) {
                        if (!parent.children) {
                            parent.children = []
                        }
                        parent.children.push(item)
                    }
                }
            })

            const tree = roots

            console.log(roots, 'roots')

            // treeData格式必须遵循ztreeview treeNode规范
            return tree
        },
        selectedRowsChange(row) {
            this.$bus.emit('selectRow', row) // 传给借阅申请的子表
        },
        cellSelectionStatus(row, index) {
            if (this.pageType === 'innerDialog') {
                return row.flType !== '2' // true表示可选择，false表示不可选择
            } else {
                return true // true表示可选择，false表示不可选择
            }
        },
        setShowView: function () {
            if (this.$route.fullPath.indexOf('itemurl=') !== -1) {
                this.showView = 'mainform'
            } else {
                this.showView = 'listpage'
            }
        },
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad: function ($scope, qparams) {
            this.loginUser = $scope.loginUser
            if (this.currentDataid === '0') {
                qparams.urlsearch = ''
            } else {
                qparams.urlsearch = `fullId like ${this.currentDataid};id!:${this.currentDataid}`
            }
            if (!qparams.orderBy) {
                qparams.orderBy = 'flType desc'
            }
            console.log('fgsgl listdata before load..')
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded: function ($scope, pageInfo) {
            console.log('fgsgl listdata loaded')
        },
        /**
         * 数据删除成功，ids为已删除成功的fgsgl对象ID数组，即将刷新列表，不需要返回值
         */
        onDeleteSuccessed: function ($scope, ids) {
            console.log('fgsgl delete successed')
        },
        /**
         * 表单打开检查，vo为已加载fgsgl对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            if (process.env.NODE_ENV === 'development') console.log('fgsgl form before open')
            defer.resolve(true)
        },
        /**
         * 表单打开完成，vo为已加载的fgsgl对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
         */
        onBasicFormOpened: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('fgsgl form opened')
        },
        /**
         * 表单提交事件，可执行业务数据高级校验，vo为待提交的fgsgl对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
         */
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
            /*this.$confirm('您是否确认提交保存?', '确认操作', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
                  .then(() => {
                      defer.resolve(true)
                  })
                  .catch(err => {
                      defer.reject(err)
                  })*/

            if (process.env.NODE_ENV === 'development') console.log('fgsgl form submit validation success')
            defer.resolve(true)
        },
        /**
         * 表单提交完成，vo为已保存成功的fgsgl对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited: function ($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('fgsgl form submited')
        }
    }
}
</script>

<style scoped lang="scss">
.panel-right {
    position: relative;
    height: calc(100vh - 50px - 50px - 60px - 22px - 20px);
    .el-button-group {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 99;
    }
}
/deep/ .panel-left .el-tree-node__content {
    height: 30px;
    line-height: 20px;
    border-bottom: none;
    span {
        span {
            font-size: 14px !important;
        }
    }
}
.input-with-select {
    width: 400px;
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: var(--bgColor) !important;
    color: var(--textColor) !important;
}
.el-tree {
    /* 设置滚动条thumb（滑块）的颜色 */
    &::-webkit-scrollbar-thumb {
        background-color: #d2d4da;
        border-radius: 6px;
    }

    /* 增加滚动条的宽度，高度 */
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    &::-webkit-scrollbar-thumb:hover {
        background-color: #d2d4da;
        cursor: pointer;
    }
}
.empty-tree {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
    font-size: 14px;
}

.right-main {
    display: flex;
    margin-right: 11px;
    margin-left: 10px;
    font-size: 13px;
    align-items: center;
    position: relative;
    .formTapBtn {
        position: absolute;
        top: 0px;
        display: flex;
        left: 50px;
        font-family: MicrosoftYaHei;
        color: #000000;
        font-size: 14px;
        width: 100%;
        .tapItemBtn {
            position: relative;
            margin-right: 15px;
        }
        .active {
            position: relative;
            color: var(--subjectColor);
            font-weight: bold;
            &::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 0px;
                width: 100%;
                height: 2px;
                background: var(--subjectColor);
            }
        }
        .tapItemBtn:hover {
            cursor: pointer;
            color: var(--subjectColor);
        }
    }
    .hytz-main .el-table-toolbar-left {
        width: 70% !important;
    }
    .hytz-main .el-table-toolbar-right {
        width: 30% !important;
    }
}
</style>
